export class PortAlias {
  Id:number;
  PortId:number;
  PortAliasName:string;
  PortName:string;
}
